import "@ai4/form-builder/dist/index.css";
import { useEffect, useState, useRef } from "react";

function Pagination(props) {
    const {
        isApplicationFilterActive,
        defaultPage,
        setDefaultPage,
        paginationValue,
        callApiGet,
        paginationTotalCount,
        paginationTotalPages,
        paginationCurrentPage,
        apiRequestValues,
        categories,
    } = props;

    const [isOpenPagination, setIsOpenPagination] = useState<boolean>(false);
    const [levelFilter, setLevelFilter] = useState<string>("All");

    function useOutsideAlerter(ref) {
        useEffect(() => {
            // closePagination menu if clicked on outside of element
            function handleClickOutside(event) {
                if (ref.current && !ref.current.contains(event.target)) {
                    setIsOpenPagination(false);
                }
            }
            // Bind the event listener
            document.addEventListener("mousedown", handleClickOutside);
            return () => {
                // Unbind the event listener on clean up
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }, [ref]);
    }

    useEffect(() => {
        if (isApplicationFilterActive) {
            setLevelFilter("All");
        }
    }, [apiRequestValues, isApplicationFilterActive]);

    const paginationRef = useRef(null);
    useOutsideAlerter(paginationRef);

    const togglePaginationMenu = () => {
        setIsOpenPagination(!isOpenPagination);
    };

    const onChangePaginationValue = (e) => {
        setLevelFilter("All");
        setDefaultPage(e.target.value);
        setIsOpenPagination(false);
        callApiGet(
            e.target.value,
            paginationCurrentPage,
            apiRequestValues[0],
            apiRequestValues[1],
            apiRequestValues[2],
            apiRequestValues[3],
            apiRequestValues[4],
            apiRequestValues[5],
            apiRequestValues[6],
            apiRequestValues[7]
        );
    };

    const onChangePage = (e, isNumberButton) => {
        setLevelFilter("All");
        const pageArgument = isNumberButton ? e.target.value : e;
        callApiGet(
            defaultPage,
            pageArgument,
            apiRequestValues[0],
            apiRequestValues[1],
            apiRequestValues[2],
            apiRequestValues[3],
            apiRequestValues[4],
            apiRequestValues[5],
            apiRequestValues[6],
            apiRequestValues[7]
        );
    };

    const getPaginationNumber = () => {
        let content: Array<any> = [];
        for (let index = 1; index <= paginationTotalPages; index++) {
            content.push(
                <li key={index}
                    className={
                        paginationCurrentPage === index ? "active page-item" : "page-item"
                    }
                    title={index.toString()}
                >
                    <button
                        className="page-link"
                        value={index}
                        onClick={(e) => onChangePage(e, true)}
                    >
                        {index}
                    </button>
                </li>
            );
        }
        return content;
    };

    const getTotalCountLabel = () => {
        let currentResultStart = 1;
        let currentResultEnd = defaultPage;
        if (paginationCurrentPage > 1) {
            for (let index = 1; index < paginationCurrentPage; index++) {
                currentResultStart = currentResultStart + parseInt(defaultPage);
            }
        }
        currentResultEnd = paginationCurrentPage * currentResultEnd;

        return ` Risultati da ${currentResultStart} a ${paginationTotalCount > currentResultEnd ? currentResultEnd : paginationTotalCount}`;
    };

    let category: any = [];
    let categorySize: any = [];
    if (typeof categories !== "undefined" && categories !== null) {
        categorySize = new Set<string>(categories.map((value) => value.category));
        category = categorySize.values();
    }

    return (
        <>
            <div
                className={
                    paginationTotalCount > 0
                        ? "row react-bootstrap-table-pagination"
                        : "d-none"
                }
            >
                <div className="col-md-6 col-xs-6 col-sm-6 col-lg-6">
                    <button
                        className="btn btn-default btn-secondary dropdown-toggle"
                        onClick={togglePaginationMenu}
                    >
                        {defaultPage}
                    </button>
                    <ul
                        ref={paginationRef}
                        className={
                            isOpenPagination ? "dropdown-menu open show" : "dropdown-menu"
                        }
                    >
                        {paginationValue.map((page, index) => (
                            <li
                                key={index}
                                className="dropdown-item"
                                value={page}
                                onClick={(e) => onChangePaginationValue(e)}
                                style={{ cursor: "pointer" }}
                            >
                                {page}
                            </li>
                        ))}
                    </ul>
                    {getTotalCountLabel()}
                    <span className="react-bootstrap-table-pagination-total">
                        {paginationTotalCount > 1
                            ? ` di ${paginationTotalCount} totali`
                            : ""}
                    </span>
                </div>
                <div className="react-bootstrap-table-pagination-list col-md-6 col-xs-6 col-sm-6 col-lg-6">
                    <ul className="pagination react-bootstrap-table-page-btns-ul">
                        {paginationCurrentPage > 1 ? (
                            <li className="page-item prev-button" title="prevPage">
                                <button
                                    className="page-link"
                                    value="prevPage"
                                    onClick={() =>
                                        onChangePage(paginationCurrentPage - 1, false)
                                    }
                                >
                                    Prec.
                                </button>
                            </li>
                        ) : (
                            ""
                        )}

                        {getPaginationNumber()}
                        {paginationTotalPages !== paginationCurrentPage ? (
                            <li className="page-item next-button" title="nextPage">
                                <button
                                    className="page-link"
                                    value="nextPage"
                                    onClick={() =>
                                        onChangePage(paginationCurrentPage + 1, false)
                                    }
                                >
                                    Succ.
                                </button>
                            </li>
                        ) : (
                            ""
                        )}
                    </ul>
                </div>
            </div>
        </>
    );
}

export default Pagination;
